var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightBcMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 19C11 19.5523 10.5523 20 10 20L3 20C1.34315 20 1.17422e-07 18.6569 2.62268e-07 17L1.48619e-06 3C1.63103e-06 1.34314 1.34315 -8.44229e-07 3 -6.99382e-07L10 -8.74228e-08C10.5523 -3.91405e-08 11 0.447716 11 1C11 1.55228 10.5523 2 10 2L3 2C2.44772 2 2 2.44771 2 3L2 17C2 17.5523 2.44772 18 3 18L10 18C10.5523 18 11 18.4477 11 19Z",
    fill: "#FF0001"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBcMask);
export default __webpack_public_path__ + "static/media/rightBCMask.081292c9e4ea2a634e26f9aadc10ae2e.svg";
export { ForwardRef as ReactComponent };